// @flow

import type { DateString } from './date-string'
import type { Salutation } from './salutation'
import { SALUTATION_UNKNOWN } from './salutation'
import { CustomerNumber } from './customer-number'

export type CustomerDetails = {
  firstName: ?string,
  surname: ?string,
  surnamePrefix: ?string,
  salutation: Salutation,
  emailAddress: ?string,
  dateOfBirth: ?DateString,
  phoneNumber: ?string,
  bankAccountNumber: ?string,
  customerNumber: ?CustomerNumber
}

const buildCustomerDetails = function (): CustomerDetails {
  return {
    firstName: '',
    surname: '',
    surnamePrefix: '',
    salutation: SALUTATION_UNKNOWN,
    emailAddress: '',
    dateOfBirth: null,
    phoneNumber: '',
    bankAccountNumber: '',
    customerNumber: null
  }
}

export {
  buildCustomerDetails
}



// WEBPACK FOOTER //
// ./src/types/customer-details.js